<template>
  <div class="player h-full flex items-stretch divide-x divide-gray-500 divide-opacity-25">
    <div class="placement w-16 flex-shrink-0 space-x-1 flex items-center justify-between text-center pl-2 pr-1">
      <small class="w-6 font-bold">
        <span :class="source[sortMode].placementDiff > 0 ? 'positive' : 'negative'" v-if="source[sortMode] && source[sortMode].placementDiff">{{ abs(source[sortMode].placementDiff) }}</span>
      </small>
      <span class="w-6 text-center text-sm" v-if="source[sortMode]">{{ source[sortMode].placement }}</span>
    </div>
    <div class="flex-1 flex overflow-hidden items-center justify-between px-2 font-bold">
      <div class="flex-1 py-1 truncate" :title="source.name"><i class="mr-1 flex-shrink-0 rounded-sm flag-icon bg-gray-400" :class="`flag-icon-${source.country}`" :title="source.country" />{{ source.name }}</div>
      <i class="star fa fa-star flex-shrink-0 pl-1 cursor-pointer select-none text-opacity-25 text-gray-600 hover:text-opacity-50" :class="{ 'text-opacity-75': sticked.includes(source.id) }" title="Add to favorite" @click="stickPlayer(source.id)" />
      <i class="stats fa fa-crosshairs hidden lg:block flex-shrink-0 ml-1 cursor-pointer select-none text-opacity-25 text-gray-600 hover:text-opacity-50" :class="{ 'text-opacity-75': shownStats.includes(source.id) }" title="Season weapon stats" @click="toggleStats(source.id)" />
      <a v-if="test" :href="`/diabotical/stats/match/?count=15&user=${source.name}`" target="_blank" class="matches ml-1 flex-shrink-0 text-opacity-25 text-gray-600 hover:text-opacity-50 select-none" title="Open last matches">
        <i class="fa fa-th-list" />
      </a>
    </div>
    <template v-if="loadedStats[source.id] && shownStats.includes(source.id)">
      <div class="weapon hidden lg:flex items-center justify-center font-bold px-1 py-2 flex-shrink-0" :class="index" v-for="(weapon, index) in weapons" :key="index">
        <LeaderboardWeapon class="rank flex-shrink-0 mx-1" :weapon="weapon.index" />
        <div class="flex-1 flex flex-wrap items-center ml-1" v-if="loadedStats[source.id][hoveredMode][index]">
          <span :title="`${loadedStats[source.id][hoveredMode][index].hits} hits / ${loadedStats[source.id][hoveredMode][index].shots} shots`">{{ loadedStats[source.id][hoveredMode][index].percent }}%</span>
          <small class="w-full font-normal text-gray-600" :title="`${loadedStats[source.id][hoveredMode][index].frags} frags / ${loadedStats[source.id][hoveredMode][index].deaths} deaths`">K/D {{ loadedStats[source.id][hoveredMode][index].kd }}</small>
        </div>
        <small class="flex-1 flex items-center justify-center text-gray-500" v-else>
          —
        </small>
      </div>
    </template>
    <template v-else>
      <div class="rating hidden lg:flex items-center justify-center font-bold px-1 py-2 flex-shrink-0" :class="mode.id" v-for="mode in modes" :key="mode.id">
        <template v-if="source[mode.id]">
          <LeaderboardRank class="rank flex-shrink-0" :tier="source[mode.id].tier" />
          <div class="flex-1 flex flex-wrap items-center ml-1">
            {{ source[mode.id].rating }}<small class="ml-1" :class="source[mode.id].ratingDiff > 0 ? 'positive' : 'negative'" v-if="source[mode.id].ratingDiff">{{ source[mode.id].ratingDiff }}</small>
            <small class="w-full font-normal text-gray-600" title="wins / matches">{{ source[mode.id].wins }} / {{ source[mode.id].matches }}</small>
          </div>
        </template>
        <small class="w-full h-full flex items-center justify-center text-gray-500" title="No rating or out of Top-500" v-else>—</small>
      </div>
    </template>
  </div>
</template>

<script>
  import { mapActions, mapGetters, mapState } from 'vuex'
  import LeaderboardRank from './LeaderboardRank.vue'
  import LeaderboardWeapon from './LeaderboardWeapon.vue'

  export default {
    name: 'LeaderboardPlayer',
    components: { LeaderboardRank, LeaderboardWeapon },
    props: {
      index: {
        type: Number,
      },
      source: {
        type: Object,
        default() {
          return {}
        },
      },
    },
    computed: {
      ...mapState(['weapons', 'sticked', 'shownStats', 'loadedStats', 'hoveredMode', 'test']),
      ...mapGetters(['sortMode', 'modes']),
    },
    methods: {
      ...mapActions(['stickPlayer', 'toggleStats']),
      abs(n) {
        return Math.abs(n)
      },
    },
  }
</script>

<style scoped>
  .player > div:nth-child(1),
  .player > div:nth-child(2) {
    background-color: rgba(255, 255, 255, 0.3);
  }

  .weapon {
    width: 6.3rem;
  }
  .weapon:last-child {
    width: 6.4rem;
  }

  .rating {
    width: 7.1rem;
  }

  .star.active {
    color: #666;
  }
  .stats.active {
    color: #666;
  }

  .positive {
    color: #090;
  }
  .negative {
    color: #c00;
  }

  .placement .positive:before {
    content: '▲';
    display: block;
    line-height: 1.2;
  }
  .placement .negative:after {
    content: '▼';
    display: block;
    line-height: 1.2;
  }

  .rating .positive:before {
    content: '+';
  }
</style>
